export default "__VITE_ASSET__DCGHxqey__"